module.exports = __webpack_public_path__ + "static/media/husite.3184ac58.mp4";